import script from "./service-default-config.vue?vue&type=script&setup=true&lang=js"
export * from "./service-default-config.vue?vue&type=script&setup=true&lang=js"

import "./service-default-config.vue?vue&type=style&index=0&id=e4f69a00&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4f69a00"]])

export default __exports__